const productQueries = `
products {
  brand
  productId
  colorFamily
  productName
  isDenim
  badges {
    label
    brand
    earlyAccess
  }
  swatchLabel
  longDescription
  shortDescription
  storeItemNumber
  webItemNumber
  sizeChartType
  sizeChartSeq
  hasSizingFormat
  fisEligibility
  popinsEligibility
  isJeans
  hasSizeGuide
  isEarlyAccess
  isFinalSale
  maxPurchaseQty
  swatchName
  kicId
  swatchImageUrl
  defaultSwatchSequence
  hasGarmentMeasurements
  hasFitInfo
  fabricDetails
  careDetailsList {
    value
    key
  }
  lowestInventoryCount
  garmentMeasurements {
    baseMeasurementSize
    baseInseamXShortMeasurement
    baseLegOpeningMeasurement
    baseInseamRegularMeasurement
    baseInseamShortMeasurement
    baseInseamLongMeasurement
    baseShoulderToHemMeasurement
    baseSleeveLengthMeasurement
    baseFrontRiseMeasurement
    baseSkirtLengthMeasurement
    eyewearDimensionLensWidth
    eyewearDimensionBridgeWidth
    eyewearDimensionArmLength
  }
  imageSet {
    prod {
      imageId
      mainImageSrc
      thumbnailSrc
      zoomImageSrc
      type
    }
    model {
      imageId
      mainImageSrc
      thumbnailSrc
      zoomImageSrc
      type
    }
    life {
      imageId
      mainImageSrc
      thumbnailSrc
      zoomImageSrc
      type
    }
    ugc {
      imageId
      mainImageSrc
      thumbnailSrc
      zoomImageSrc
      type
    }
  },
  orderedImages {
    imageId
    mainImageSrc
    thumbnailSrc
    zoomImageSrc
    type
    imgTypeIndex
    ofpModelHeight
    ofpModelSize
  }
  fitInformation {
    ofpModelHeight
    ofpModelSize
  }
  prices {
    list {
      discountPrice
      discountText
      originalPrice
      description
      variant
      listPriceUSD
      offerPriceUSD
    }
    member {
      discountText
      originalPrice
      description
      variant
    }
  }
  priceFlag
  merchPromoMessage {
    type
    message
  }
  departmentName
  gender
  suggestedSearchAttributes {
    id
    breadcrumbs
    breadcrumbsEN
    colorFamily
    gender
    productName
    productNameEN
    AI_Attributes {
      name
      value {
        id
        value
      }
    }
  }
  breadcrumbCategoryHierarchy {
    categoryName_EN
    categoryName
    categoryId
  }
  productNameEn
  productPageUrl
  analyticsSwatchAvailability
  published
  hasProductSets
}
primarySizeGroupHeading
secondarySizeGroupHeading
primarySizeArray {
  sizeText
  value
  label
  valueSequence
  description
}
secondarySizeArray {
  sizeText
  value
  label
  valueSequence
  description
}
sizeTileAttrs {
  primaryTileSize
  secondaryTileSize
}
skus {
  inventory
  inventoryStatus
  productId
  shortSku
  sizePrimary
  sizeSecondary
  fullSizeLabel
}
shopSimilarUrl
isLoyaltyRegion
breadcrumbsUrls {
  name
  enName
  url
  categoryId
}
isOmniEnabled
isNewMfeOmniEnabled
howToMeasureContentCode
isPDPExternalVisitorEnabled
hasMobileAltImageThumbnail
siteRegion
hasPDPMFEBelowTheFold
isSoldOut
hasGermanTax
primaryCategoryId
hasSocialProofingEnabled
joinedKics
hasDenimElevatedAttrFeatureTest
hasStickyAddToBagDesktopEnabled
hasCompareOurFabricsEnabled
hasAddToBagTextSplitTest
brandObject {
  key
  name
  parentBrand
}
addToBagSplitTestKeys {
  activeLabel
  successLabel
}
collectionHasDenim
published
productUrl
hasProductMfeSeoSchema
hasProductRecsStoreAttr
hasMemberPricingEnabled
styliticsV3Locale
hasReviewsLegalText
hasPDPElevatedRecs
isEyewearProduct
loudCrowdShopId
hasBazaarvoiceMFEEnabled
hasSelectableSoldOutSizeTiles
hasMatchingSetsPdpEnabled
matchingSets {
  kicId
  collectionId
  productId
  name
  imageId
  imageUrl
  prices {
    list {
      originalPrice
      discountPrice
      description
      variant
    }
  }
  brand
}
`;

export default productQueries;
